import {NgModule} from '@angular/core';
import {ToggleComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SimpleMaskModule} from '@initru/ngx-ion-simple-mask';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    SimpleMaskModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ToggleComponent
  ],
  declarations: [ToggleComponent],
  providers: [],
})
export class ToggleComponentModule {
}
